// This file is AUTOGENERATED, do not edit it manually!!!

export const projectFinancials = {
    actual_billing: 'Faturamento Real',
    actual_cost: 'Custo Real',
    ActualBillableExpenses: 'Despesas Faturáveis Reais',
    ActualBillableExpensesShort: 'Despesas Faturáveis Reais',
    ActualBilledShort: 'Faturado Real',
    ActualBillingShort: 'Faturamento Real',
    ActualBudgetProfitability: 'Rentabilidade do Orçamento Real',
    ActualCost: 'Custo Real',
    ActualCostQtip: 'Custo Real = Custo da Mão-de-Obra Real + Despesas Reais',
    ActualExpenses: 'Despesas Reais',
    ActualExpensesListTitle: 'Real',
    ActualExpensesShort: 'Despesas Reais',
    ActualHours: 'Horas Reais',
    ActualLaborBilling: 'Mão-de-Obra Faturável Real',
    ActualLaborBillingShort: 'Mão-de-Obra Faturável Real',
    ActualLaborCost: 'Custo da Mão-de-Obra Real',
    ActualLaborCostShort: 'Custo da Mão-de-Obra Real',
    add_activities_flat_fees: 'adicionar atividades com taxas fixas',
    add_as_actual_expense: 'Adicionar como despesa real',
    add_planned_billable_expenses: 'adicionar despesas faturáveis planejadas',
    add_received_payment: 'Adicionar pagamento recebido',
    add_scheduled_payment: 'Adicionar pagamento programado',
    AddActivitiesBudgets: 'adicionar orçamentos de atividades',
    AddBudgetLabel: 'Adicionar Orçamento para este Projeto',
    AddPlannedExpenses: 'adicionar despesas planejadas',
    Amount: 'Quantidade',
    ApproveTooltip: 'Transfere despesas planejadas para reais',
    back_to_metrics: 'Voltar às métricas',
    batch_actual_text: 'Adicionar como Despesas Reais',
    batch_billed_text: 'Marcar como Faturado',
    batch_operation_failed_description: 'A operação não pôde ser concluída para esta despesa. Isso pode ser devido à exclusão dela ou à falta de permissões para realizar operações. Consulte o administrador do {brandName} para possíveis causas.',
    batch_operations_failed_description: 'A operação não pôde ser concluída para {0} de {1} despesas. Isso pode ser devido à exclusão delas ou à falta de permissões para realizar operações. Consulte o administrador do {brandName} para possíveis causas.',
    Billable: 'Faturável',
    Billed: 'Faturado',
    BilledPercentQtip: 'Faturado = (Mão-de-Obra Faturada + Despesas Faturadas) / EAC Faturável * 100%',
    BilledVsActualCost: 'Faturado vs Custo Real',
    Billing: 'Faturamento',
    Billing_Info_Title: 'Informações de Faturamento',
    BillingHelp: 'Na seção de Faturamento, você pode escolher o tipo certo de faturamento para seu projeto e definir uma taxa, como por hora, ou um valor fixo para um projeto de taxa fixa.',
    BillingSettings: 'Configurações de Faturamento',
    BillingSettingsTitle: 'Faturamento',
    BillingType: 'Tipo de Faturamento',
    BillingTypeLabel: 'Calcular por ',
    BillingUtilization: 'Utilização de Faturamento Antecipado',
    BudgetedCost: 'Orçamento Total do Projeto',
    BudgetHelp: 'Nesta seção, você pode visualizar o orçamento total do projeto composto por todas as suas atividades e definir um orçamento no nível do projeto.',
    CancelTooltip: 'Cancelar',
    chart_actual_billing: 'Faturamento Real',
    chart_actual_cost: 'Custo Real',
    chart_billable_expenses: 'Despesas Faturáveis',
    chart_billed: 'Faturado',
    chart_billed_expenses: 'Despesas Faturadas',
    chart_eac_billing: 'EAC Faturável',
    chart_expenses: 'Despesas',
    chart_non_billable_expenses: 'Despesas Não Faturáveis',
    chart_payments: 'Pagamentos Recebidos',
    chart_scheduled_payments: 'Pagamentos Programados',
    ContingencyPadding: 'Contingência',
    Cost: 'Custo Total',
    CPI: 'CPI',
    CurrencyLabel: 'Moeda',
    CustomerHourlyRateLabel: 'Taxa Horária do Cliente',
    Date: 'Data',
    delete_the_expense_title: 'Excluir a despesa',
    delete_the_payment_title: 'Excluir o pagamento',
    DeletePaymentConfirmation: 'Tem certeza de que deseja excluir esse registro?',
    DeleteTooltip: 'Excluir',
    Description: 'Descrição',
    DetailedReportTitleTemplate: 'Relatório Detalhado para {0}',
    EAC: 'Estimativa no Término',
    eac_billing: 'Estimativa no Término (EAC) Faturável',
    eac_cost: 'Estimativa no Término (EAC) Custo',
    EACBilling: 'EAC Faturável',
    EACBillingLong: 'Estimativa no Término (EAC) Faturável',
    EACBillingQtip: 'Estimativa no Término (EAC) Faturável = Faturamento Real + ETC Faturável',
    EACBillingQtipInfo: 'Valor total estimado faturável incluindo mão-de-obra faturável e despesas faturáveis (Real + Estimativa para Completação (ETC))',
    EACCost: 'Estimativa no Término (EAC) Custo',
    EACCost_short: 'Custo EAC',
    EACCostQtip: 'Estimativa no Término (EAC) Custo = Custo Real + ETC Custo',
    EnteredBy: 'Inserido Por',
    EstimatedBudgetProfitability: 'Rentabilidade Orçamentária Estimada',
    EstimatedCostVariance: 'Variação de Custo Estimada',
    EstimatedExpenses: 'Despesas Estimadas',
    EstimatedHours: 'Horas Estimadas',
    EstimatedProfit: 'Lucro Esperado',
    EstimatedProfitPercentQtip: 'Lucro Esperado (%) = (EAC Faturável - EAC Custo) / EAC Faturável * 100%',
    EstimatedProfitQtip: 'Lucro Esperado = EAC Faturável - EAC Custo',
    etc_billing: 'Estimativa para Completação (ETC) Faturável',
    etc_cost: 'Estimativa para Completação (ETC) Custo',
    ETCBillableExpenses: 'Despesas Faturáveis ETC',
    ETCBillableExpensesShort: 'Despesas Faturáveis ETC',
    ETCBilling: 'ETC Faturável',
    ETCBillingShort: 'ETC Faturável',
    ETCCost: 'Custo ETC',
    ETCCostShort: 'Custo ETC',
    ETCCosttQtip: 'Estimativa para Completação (ETC) Custo = Custo da Mão-de-Obra ETC + Despesas ETC',
    ETCExpenses: 'Despesas ETC',
    ETCExpensesShort: 'Despesas ETC',
    ETCLaborBilling: 'Mão-de-Obra Faturável ETC',
    ETCLaborBillingShort: 'Mão-de-Obra Faturável ETC',
    ETCLaborCost: 'Custo da Mão-de-Obra ETC',
    ETCLaborCostShort: 'Custo da Mão-de-Obra ETC',
    ExpectedRevenue: 'Receita Esperada',
    expenses: '1#{0} despesa#{0} despesas',
    expenses_updated_successfully_plural: '1#Despesa foi atualizada com sucesso.#{0} despesas foram atualizadas com sucesso.',
    FeeAmount: 'Valor da taxa',
    FlatFee: 'Taxa fixa',
    GeneralInfo: 'Informações gerais',
    HourlyRate: 'Taxa horária',
    InternalBudget: 'Orçamento',
    InternalEstimatedCost: 'Custo estimado interno',
    LaborBilling: 'Trabalho Faturável',
    LaborCost: 'Custo de Mão de Obra',
    legend_actual: 'Atual',
    legend_estimated_at_completion: 'Estimativa na conclusão',
    log_actual_expense: 'Registrar despesa real',
    log_expenses: 'Registrar despesas',
    log_payments: 'Registrar Pagamentos',
    log_planned_expense: 'Registrar despesa planejada',
    money_for_date_label: '{0} para {1}?',
    no_targets: 'Não há metas para exibir',
    NoActualExpenses: 'Não há despesas.',
    None: 'Nenhum',
    NoneCurrency: 'Escolha a moeda',
    NoPayments: 'Não há pagamentos.',
    NoPlannedExpenses: 'Não há despesas planejadas.',
    NotBillable: 'Não faturável',
    NotBillableLabel: 'Não faturável',
    NotBilled: 'Não faturado',
    OpenRateCard: 'Cartão de taxas aberto',
    OutstandingPaymentBalance: 'Saldo de Pagamento Pendente',
    PaymentDescriptionWatermark: 'Descrição...',
    PaymentReceived: 'Pagamento Recebido',
    payments_total: '1#{0} pagamento#{0} pagamentos',
    PaymentsOfSchedPayments: 'Pagamentos de Pagamentos Agendados',
    PercentageBilled: 'Porcentagem Faturada',
    PercentageProjectBilled: 'Porcentagem Faturada',
    Percentages: 'Porcentagem',
    PlannedExpenses: 'Despesas Planejadas',
    PlannedExpensesListTitle: 'Planejado',
    ppFormat: '{0}pp',
    Profit: 'Lucro',
    ProfitQtip: 'Lucro = Faturamento Atual - Custo Atual',
    Project_no_rateCard_for_rateCard_billingType: 'Você deve especificar um cartão de taxa se a faturamento do projeto é baseado em um cartão de taxa.',
    ProjectActivityName: 'Nome do Projeto / Atividade',
    ProjectBilling: 'Cobrança do Projeto',
    ProjectBillingIsBasedOn: 'A cobrança do projeto é baseada em',
    ProjectBillingUtilization: 'Utilização de Cobrança',
    ProjectBudget: 'Orçamento de Mão de Obra',
    ProjectCost: 'Custo Interno do Projeto',
    ProjectCostVariance: 'Variação de Custo do Projeto',
    ProjectEarnedValue: 'Valor Agregado do Projeto',
    ProjectEarnedValueInfo: 'Representa a saúde do projeto',
    ProjectExpectedRevenue: 'Receita Esperada do Projeto',
    ProjectFixedCostLabel: 'Taxa fixa do Projeto',
    ProjectHourlyRateLabel: 'Taxa horária do Projeto',
    ProjectPayments: 'Pagamentos do Projeto',
    ProjectPlannedExpenses: 'Despesas Planejadas do Projeto',
    ProjectPlannedExpensesInfo: 'Despesas planejadas para um projeto específico e despesas planejadas agregadas de suas atividades',
    ProjectProfit: 'Lucro do Projeto',
    ProjectProfitability: 'Rentabilidade do Projeto',
    ProjectProfitabilityInfo: 'Representa a porcentagem de valor criado por projeto',
    ProjectTimeUsage: 'Uso do Tempo do Projeto',
    ProjectTimeUsageInfo: 'Exibe quanto do tempo orçado utilizamos, atual como porcentagem de horas estimadas',
    ProjectWorkInProgress: 'Trabalho em Andamento do Projeto',
    PymentsVsActualCost: 'Pagamentos vs Custo Atual',
    RateCardLabel: 'Cartão de Taxas',
    Receipt: 'Recibo',
    Received: 'Recebido',
    ReceivedPaymentsListTitle: 'Recebido',
    RemainingInternalBudget: 'Orçamento Restante',
    RemainingInternalBudgetQtip: 'Orçamento Restante = Orçamento - Custo Atual',
    RemainingInternalBudgetQtipForProject: 'Orçamento Restante = Orçamento Total - Custo Atual',
    ResourceHourlyRateLabel: 'Taxa horária do Recurso',
    Revenue: 'Receita',
    Scheduled: 'Agendado',
    ScheduledPaymentsListTitle: 'Agendado',
    set_targets: 'Defina metas usando o',
    Settings: 'Configurações',
    ShowAll: 'MOSTRAR TUDO',
    ShowBreakdown: 'Mostrar detalhes',
    ShowFull: 'MOSTRAR COMPLETO',
    SPI: 'SPI',
    tab_Actual: 'Despesas Reais',
    tab_expenses: 'Despesas',
    tab_overview: 'Visão Geral',
    tab_payments: 'Pagamentos',
    tab_Planned: 'Despesas Planejadas',
    tab_Received: 'Pagamentos Recebidos',
    tab_Scheduled: 'Pagamentos Agendados',
    tab_targets: 'Metas',
    TargetBudget: 'Orçamento Total',
    TargetLaborRevenue: 'Receita de Mão de Obra Alvo',
    TargetProfit: 'Lucro Planejado',
    TargetRevenue: 'Receita Alvo',
    Targets: 'Metas',
    targets_tab: 'Aba de Metas',
    TargetsEACBilling: 'EAC Faturável',
    TaskRateLabel: 'Taxa de Atividade',
    TimeAndMaterial: 'Tempo & Material',
    TimeUsage: 'Uso de Tempo',
    TitleText: 'Financeiro',
    total_billable: 'Total Faturável',
    TotalBilled: 'Total Faturado',
    TotalProjectBudget: 'Orçamento Total do Projeto',
    TotalProjectPayments: 'Pagamentos Totais do Projeto',
    TotalProjectPaymentsInfo: 'Resumo de todos os pagamentos feitos por todos os clientes',
    TotalTargetRevenue: 'Receita Total Alvo',
    TrackProfitAs: 'Acompanhe lucro como',
    Validation_DateMandatory: 'Data é um campo obrigatório.',
    Validation_InvalidAmount: 'O valor deve ser um número positivo.',
    Validation_InvalidDate: 'A data deve estar no formato \'{0}\'.',
    Validation_Range: 'O valor não está dentro do intervalo esperado.',
    Variance: 'Variação',
    warning_currency: 'A moeda é retirada do cartão de taxas escolhido',
    WorkInProgress: 'Trabalho em Andamento',
};
